var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "gif-sticker-container",
      on: { click: _vm.reconnectConciergerie },
    },
    [
      _c(
        "Tooltip",
        {
          attrs: {
            active: _vm.disabled || !_vm.isConciergerie,
            text: !_vm.isConciergerie
              ? _vm.$t("dash.bots.status_proxy")
              : _vm.$t("dash.post.error.need_video.title"),
            position: "top",
          },
        },
        [
          _c(
            "vs-button",
            {
              staticClass: "gif-btn",
              attrs: {
                type: "border",
                color: "rgba(0, 0, 0, 0.2)",
                icon: "gif",
                disabled: _vm.disabled || !_vm.isConciergerie,
              },
              on: { click: _vm.addGif },
            },
            [_vm._v(_vm._s(_vm.$t("dash.post.btn.add_gif")))]
          ),
        ],
        1
      ),
      _vm.gifIsOpen
        ? _c("div", { staticClass: "auto-mentions row box" }, [
            _c(
              "div",
              { staticClass: "search-box-gif" },
              [
                _c("vs-input", {
                  ref: "inputSearchGif",
                  staticClass: "inputx",
                  attrs: {
                    color: "#B20564",
                    type: "text",
                    name: "search-mention",
                    placeholder: "Rechercher un gif",
                    autocomplete: "off",
                  },
                  on: {
                    keyup: _vm.searchGif,
                    click: _vm.searchGif,
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      $event.preventDefault()
                    },
                  },
                  model: {
                    value: _vm.searchedGif,
                    callback: function ($$v) {
                      _vm.searchedGif = $$v
                    },
                    expression: "searchedGif",
                  },
                }),
                _c(
                  "vs-button",
                  {
                    staticClass: "page-btn",
                    attrs: { "vs-type": "filled", color: "#6a1f4c" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.insertGif.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("OK")]
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "vs-con-loading__container gifs-list",
                attrs: { id: "loading-gif" },
              },
              _vm._l(_vm.gifsList, function (gif) {
                return _c("img", {
                  key: gif.id,
                  class: `gif-item ${
                    _vm.selectedGif &&
                    _vm.selectedGif.id === gif.id &&
                    "selected"
                  }`,
                  attrs: { src: gif.images.preview_gif.url, alt: gif.name },
                  on: {
                    click: function ($event) {
                      return _vm.selectGif(gif)
                    },
                  },
                })
              }),
              0
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }